import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "possessive"})
export class PossessivePipe implements PipeTransform {
    constructor() {
    }

    transform(value) {
        return value ? (value + "'" + (value.toLowerCase().endsWith("s") ? "" : "s")).substring(0, 25) : value;
    }
}



// WEBPACK FOOTER //
// ./src/app/string-utils/possessive.pipe.ts